import type { ReactNode } from 'react';

interface SectionHeadingProps {
  icon?: string;
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export default function SectionHeading({ icon, title, subtitle, action }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-600 text-background-50">
            <i className={`${icon} text-xl`}></i>
          </span>
        )}
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
          {subtitle && <p className="mt-0.5 text-sm text-foreground-400">{subtitle}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}